import AppService from 'App/legacy/AppService';
import type Contact from 'App/resources/Model/Contact';
import type { EsignInvolved } from 'App/resources/Model/Esign';
import type User from 'App/resources/Model/User';

type NewEsignInvolved = Pick<
	EsignInvolved,
	'sign' | 'seen' | 'fstname' | 'sndname' | 'company' | 'userId' | 'contactId' | 'deliveryMethod' | 'authMethod'
> & {
	email: string | null;
	companynr: string | null;
	personalnr: string | null;
	mobile?: string | null;
};

type Opts = {
	user?: Pick<User, 'id' | 'name' | 'email' | 'userCellPhone'>;
	contact?: Pick<Contact, 'id' | 'name' | 'email' | 'cellPhone'> & { client: Pick<Contact['client'], 'name'> };
};

export const newEsignInvolved = ({ user, contact }: Opts = {}): NewEsignInvolved => {
	const involved: NewEsignInvolved = {
		sign: null,
		seen: null,
		email: null,
		fstname: '',
		sndname: '',
		company: '',
		companynr: null,
		personalnr: null,
		userId: null,
		contactId: null,
		deliveryMethod: 'email',
		authMethod: 'standard'
	};

	const person = user || contact;
	if (person) {
		involved.email = person.email;

		const split = person.name.split(' ');
		involved.fstname = split[0];
		involved.sndname = split.length > 1 ? split[split.length - 1] : '';

		if (user) {
			involved.company = AppService.getAccountSelf().client.name;
			involved.userId = user.id;
			involved.mobile = user.userCellPhone;
		} else if (contact) {
			involved.company = contact.client.name;
			involved.contactId = contact.id;
			involved.mobile = contact.cellPhone;
		}
	}

	return involved;
};
